export const EDINEBURGH_DEPT_SCALE = {
  masterTableName: "MC_EDINBURGH_DEP_SCALE",
  tableName: "MC_EDINBURGH_DEP_SCALE_DET",
  columnName: "EDS_ID",
  columnValue: 0,
  title: "edineburgh-dept-scale.title",
  rows: [
    {
      title: "id",
      value: "ID",
      headerName: "ID",
      type: "Number",
    },
    {
      title: "EDS_ID",
      value: "EDS_ID",
    },
    {
      title: "CUSER",
      value: "CUSER",
    },
    {
      title: "CTIME",
      value: "CTIME",
      type: "date",
    },
    {
      title: "PROCESS_TIME",
      value: "PROCESS_TIME",
      type: "date",
    },
    {
      title: "DATE_BIRTH",
      value: "DATE_BIRTH",
      type: "date",
    },
    {
      title: "LAUGH_FUNNY_THINGS",
      value: "LAUGH_FUNNY_THINGS_XNAME",
    },
    {
      title: "LOOK_FUTURE_HOPEFULLY",
      value: "LOOK_FUTURE_HOPEFULLY_XNAME",
    },
    {
      title: "BAD_THINGS_BLAME_HERSELF",
      value: "BAD_THINGS_BLAME_HERSEL_XNAME",
    },
    {
      title: "FEEL_DISTRESSED_ANXIOUS",
      value: "FEEL_DISTRESSED_ANXIOUS_XNAME",
    },
    {
      title: "FEEL_FEAR_PANIC",
      value: "FEEL_FEAR_PANIC_XNAME",
    },
    {
      title: "EVERYTHING_GETTING_HARDER",
      value: "EVERYTHING_GETTING_HARD_XNAME",
    },
    {
      title: "FEEL_SAD_HARD_SLEEP",
      value: "FEEL_SAD_HARD_SLEEP_XNAME",
    },
    {
      title: "FEEL_SAD_DEPRESSED",
      value: "FEEL_SAD_DEPRESSED_XNAME",
    },
    {
      title: "FEEL_SAD_CRY",
      value: "FEEL_SAD_CRY_XNAME",
    },
    {
      title: "THINK_HURT_MYSELF",
      value: "THINK_HURT_MYSELF_XNAME",
    },
    {
      title: "FEEL_SAD_WANT_CRY",
      value: "FEEL_SAD_WANT_CRY_XNAME",
    },
    {
      title: "NOTE",
      value: "NOTE",
    },
    {
      title: "EDINBURGH_SCORE",
      value: "EDINBURGH_SCORE",
    },
  ],
  fields: [
    { field: "CUSER", headerName: "cuser", flex: 1 },
    { field: "CTIME", headerName: "ctime", flex: 1, type: "Date" },
    {
      field: "PROCESS_TIME",
      headerName: "process-time",
      flex: 1,
      type: "Date",
    },
    {
      field: "DATE_BIRTH",
      headerName: "edineburgh-dept-scale.birth-date",
      flex: 1,
      type: "Date",
    },
    {
      field: "LAUGH_FUNNY_THINGS",
      headerName: "edineburgh-dept-scale.LAUGH_FUNNY_THINGS",
      flex: 1,
    },
    {
      field: "LOOK_FUTURE_HOPEFULLY",
      headerName: "edineburgh-dept-scale.LOOK_FUTURE_HOPEFULLY",
      flex: 1,
    },
    {
      field: "BAD_THINGS_BLAME_HERSELF",
      headerName: "edineburgh-dept-scale.BAD_THINGS_BLAME_HERSELF",
      flex: 1,
    },
    {
      field: "FEEL_FEAR_PANIC",
      headerName: "edineburgh-dept-scale.FEEL_FEAR_PANIC",
      flex: 1,
    },
    {
      field: "FEEL_DISTRESSED_ANXIOUS",
      headerName: "edineburgh-dept-scale.FEEL_DISTRESSED_ANXIOUS",
      flex: 1,
    },
    {
      field: "EVERYTHING_GETTING_HARDER",
      headerName: "edineburgh-dept-scale.EVERYTHING_GETTING_HARDER",
      flex: 1,
    },
    {
      field: "FEEL_SAD_HARD_SLEEP",
      headerName: "edineburgh-dept-scale.FEEL_SAD_HARD_SLEEP",
      flex: 1,
    },
    {
      field: "FEEL_SAD_CRY",
      headerName: "edineburgh-dept-scale.FEEL_SAD_CRY",
      flex: 1,
    },
    {
      field: "THINK_HURT_MYSELF",
      headerName: "edineburgh-dept-scale.THINK_HURT_MYSELF",
      flex: 1,
    },
    {
      field: "FEEL_SAD_WANT_CRY",
      headerName: "edineburgh-dept-scale.FEEL_SAD_DEPRESSED",
      flex: 1,
    },
    {
      field: "NOTE",
      headerName: "edineburgh-dept-scale.note",
      flex: 1,
    },
    {
      field: "EDINBURGH_SCORE",
      headerName: "edineburgh-dept-scale.score",
      flex: 1,
      computed: false,
      calculate: (row: any) => {
        if (!row) return 0;

        const think_hurt_myself = Number(row.THINK_HURT_MYSELF_XVALUE) || 0;
        const feel_sad_cry = Number(row.FEEL_SAD_CRY_XVALUE) || 0;
        const feel_sad_depressed = Number(row.FEEL_SAD_DEPRESSED_XVALUE) || 0;
        const feel_sad_hard_sleep =
          Number(row.FEEL_SAD_HARD_SLEEP_XVALUE) || 0;
        const everything_getting_harder =
          Number(row.EVERYTHING_GETTING_HARD_XVALUE) || 0;
        const feel_fear_panic = Number(row.FEEL_FEAR_PANIC_XVALUE) || 0;
        const feel_distressed_anxious =
          Number(row.FEEL_DISTRESSED_ANXIOUS_XVALUE) || 0;
        const bad_things_blame_herself =
          Number(row.BAD_THINGS_BLAME_HERSEL_XVALUE) || 0;
        const look_future_hopefully =
          Number(row.LOOK_FUTURE_HOPEFULLY_XVALUE) || 0;
        const laugh_funny_things = Number(row.LAUGH_FUNNY_THINGS_XVALUE) || 0;

        const totalScore =
          laugh_funny_things +
          look_future_hopefully +
          bad_things_blame_herself +
          feel_distressed_anxious +
          feel_fear_panic +
          everything_getting_harder +
          feel_sad_hard_sleep +
          feel_sad_cry +
          think_hurt_myself +
          feel_sad_depressed;

        return totalScore;
      },
    },
  ],
  mcpConfig: {
    LAUGH_FUNNY_THINGS: {
      mcpId: 595,
      field: "LAUGH_FUNNY_THINGS",
      scoreField: "LAUGH_FUNNY_THINGS_XVALUE",
    },
    LOOK_FUTURE_HOPEFULLY: {
      mcpId: 596,
      field: "LOOK_FUTURE_HOPEFULLY",
      scoreField: "LOOK_FUTURE_HOPEFULLY_XVALUE",
    },
    BAD_THINGS_BLAME_HERSELF: {
      mcpId: 597,
      field: "BAD_THINGS_BLAME_HERSELF",
      scoreField: "BAD_THINGS_BLAME_HERSELF_XVALUE",
    },
    FEEL_DISTRESSED_ANXIOUS: {
      mcpId: 598,
      field: "FEEL_DISTRESSED_ANXIOUS",
      scoreField: "FEEL_DISTRESSED_ANXIOUS_XVALUE",
    },
    FEEL_FEAR_PANIC: {
      mcpId: 599,
      field: "FEEL_FEAR_PANIC",
      scoreField: "FEEL_FEAR_PANIC_XVALUE",
    },
    EVERYTHING_GETTING_HARDER: {
      mcpId: 600,
      field: "EVERYTHING_GETTING_HARDER",
      scoreField: "EVERYTHING_GETTING_HARDER_XVALUE",
    },
    FEEL_SAD_HARD_SLEEP: {
      mcpId: 601,
      field: "FEEL_SAD_HARD_SLEEP",
      scoreField: "FEEL_SAD_HARD_SLEEP_XVALUE",
    },
    FEEL_SAD_DEPRESSED: {
      mcpId: 602,
      field: "FEEL_SAD_DEPRESSED",
      scoreField: "FEEL_SAD_DEPRESSED_XVALUE",
    },
    FEEL_SAD_CRY: {
      mcpId: 603,
      field: "FEEL_SAD_CRY",
      scoreField: "FEEL_SAD_CRY_XVALUE",
    },
    THINK_HURT_MYSELF: {
      mcpId: 604,
      field: "THINK_HURT_MYSELF",
      scoreField: "THINK_HURT_MYSELF_XVALUE",
    },
    FEEL_SAD_WANT_CRY: {
      mcpId: 605,
      field: "FEEL_SAD_WANT_CRY",
      scoreField: "FEEL_SAD_WANT_CRY_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    EDS_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    LAUGH_FUNNY_THINGS: "",
    LOOK_FUTURE_HOPEFULLY: "",
    BAD_THINGS_BLAME_HERSELF: "",
    FEEL_DISTRESSED_ANXIOUS: "",
    FEEL_FEAR_PANIC: "",
    EVERYTHING_GETTING_HARDER: "",
    FEEL_SAD_HARD_SLEEP: "",
    FEEL_SAD_DEPRESSED: "",
    FEEL_SAD_CRY: "",
    THINK_HURT_MYSELF: "",
    FEEL_SAD_WANT_CRY: "",
    NOTE: "",
    EDINBURGH_SCORE: 0,
    DATE_BIRTH: null,
    NURSE_ID: "",
  },
  chartScoreField: "EDINBURGH_SCORE",
  chartTimeField: "PROCESS_TIME",
};
